import transactionTypes from 'constants/transactionTypes';

import { Movement, Transaction } from 'types';

import movementTypes from 'modules/transactions/constants/movementTypes';
import { createMovement } from 'modules/transactions/utils/createMovement';
import { createTransaction } from 'modules/transactions/utils/createTransaction';

import {
  ConstitutionExcelPreview,
  ConstitutionExcelPreviewItem,
} from '../types/ConstitutionExcel';

type MapConstitutionPreviewToOperationParams = {
  preview: ConstitutionExcelPreview;
  partnerIdByCif: Record<string, string>;
};

export const mapConstitutionPreviewToOperation = ({
  preview,
  partnerIdByCif,
}: MapConstitutionPreviewToOperationParams): {
  movements: Movement[];
  transactions: Transaction[];
} => {
  const movements: Movement[] = [];
  const transactions: Transaction[] = [];

  preview.items.forEach((item: ConstitutionExcelPreviewItem) => {
    const partnerId = partnerIdByCif[item.cif];

    if (!partnerId) return;

    const range = {
      from: item.shareFrom,
      to: item.shareTo,
      shareClass: item.holdingClassId,
      sharePremium: item.sharePremium,
      partner: partnerId,
    };

    movements.push(
      createMovement({
        range,
        movementType: movementTypes.INCREMENT,
      })
    );

    transactions.push(
      createTransaction({
        range,
        transactionType: transactionTypes.CONSTITUTION,
      })
    );
  });

  return { movements, transactions };
};
